import {getFirstFulfilledInSequence} from '@yourcoach/async-utils';

import type {
  CoreClientPaymentsReadParams,
  CoreCoachPaymentsReadParams,
} from '../../../api/types/core/methods';
import type {AsyncStrategy, BaseConfig, Batch} from '../utils';

import {paymentStore} from '../../../api/payment';
import {isIamCoach} from '../../../utils/entity/isIamCoach';

export {
  paymentFetch,
  /** @public */
  paymentFetchBatch,
};

type Config = BaseConfig<
  CoreClientPaymentsReadParams | CoreCoachPaymentsReadParams
>;

const strategy: AsyncStrategy = async (roles, config) => {
  return isIamCoach()
    ? getFirstFulfilledInSequence([roles.coach, roles.client], config)
    : roles.client(config);
};

async function paymentFetch(config: Config) {
  return strategy({client: asClient, coach: asCoach}, config);
}

paymentFetch.asClient = asClient;
paymentFetch.asCoach = asCoach;

async function paymentFetchBatch(config: Batch<Config>) {
  return strategy({client: asClientBatch, coach: asCoachBatch}, config);
}

paymentFetchBatch.asClient = asClientBatch;
paymentFetchBatch.asCoach = asCoachBatch;

async function asClient(config: Config) {
  return paymentStore.fetch(config.params, config.options);
}

async function asClientBatch(config: Batch<Config>) {
  return paymentStore.fetchBatch(config.params, config.options);
}

async function asCoach(config: Config) {
  return paymentStore.coach.fetch(config.params, config.options);
}

async function asCoachBatch(config: Batch<Config>) {
  return paymentStore.coach.fetchBatch(config.params, config.options);
}
